import React from 'react'
import { Select, SelectProps } from '@shared/Form/Select'
import { useDevices } from '@services/device'
import { DeviceType } from '@services/constants'

const EelectricitymeterSelect = React.forwardRef<
  typeof Select,
  SelectProps<number>
>((props: SelectProps<number>, ref): any => {
  const { dataSource, isLoading, refetch } = useDevices({
    deviceType: DeviceType.ELECTRIC_METER,
    pageNum: 0,
    pageSize: 999,
  })

  return (
    <Select ref={ref as any} loading={isLoading} allowClear {...props}>
      {dataSource?.content?.map((x: any, idx: number) => (
        <Select.Option key={idx} value={x.id}>
          {x.displayName}
        </Select.Option>
      ))}
    </Select>
  )
})

export default EelectricitymeterSelect
